import React from 'react';
import { ChipContainer, Icon, Text, getIcon } from './styles';

/**
 * Um componente de chip que exibe texto com um ícone com base no tipo especificado.
 *
 * @component
 * @param {Object} props - Propriedades do componente
 * @param {string} props.text - O conteúdo de texto a ser exibido no chip
 * @param {string} [props.type='info'] - O tipo de chip que determina o estilo e ícone. O padrão é 'info'.
 * @returns {JSX.Element} Um componente de chip estilizado com ícone e texto
 */
export function FlexChip({ text, type = 'info', ...props }) {
  return (
    <ChipContainer type={type} {...props}>
      <Icon type={type}>{getIcon(type)}</Icon>
      <Text>
        <span>{text}</span>
      </Text>
    </ChipContainer>
  );
}
